<template>
  <BuildingsEffectA />
</template>

<script>
import BuildingsEffectA from './components/BuildingsEffectA.vue'

export default {
  name: 'App',
  components: {
    BuildingsEffectA,
  },
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
